// extracted by mini-css-extract-plugin
export default {"infiniteLoader":"infinite_scroll_infiniteLoader__IbUjF"};